class usersCreateController{
  /**
   *
   * @param $users
   * @param $stateParams
   * @param CONFIG
   */
  constructor(
    $users,
    $companies,
    $stateParams,
    CONFIG,
    $state
  ){
    'ngInject';

    this.$users = $users;
    this.$state = $state;
    this.$companies = $companies;
    this.config = {
      id: $stateParams.id
    };

    const operators = JSON.parse(JSON.stringify(this.currentCompany.invoice_account.allowed_operators));

    this.user = {
      email     : null,
      firstname : null,
      lastname  : null,
      password  : null,
      operators: operators,
    };

    this.$users.setUri( `${CONFIG.API.companies}/${this.config.id}/users` );
  }
  $onSubmit( formUsersCreate ){
    this.$users.create( this.user )
      .then(() => this.$state.go('adminCompanies.detail', { id: this.config.id }))
      .finally(() => formUsersCreate.$submitted = false );
  }

  get currentCompany() {
    return this.$companies.currentCompany;
  }

  get availableOperators() {
    return this.currentCompany.invoice_account.allowed_operators;
  }

  updateOperators(operator) {
		const idx = this.user.operators.indexOf(operator);
		if (idx > -1) {
			this.user.operators.splice(idx, 1);
		} else {
			this.user.operators.push(operator);
		}
  }
}

export default usersCreateController;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users-create/users-create.controller.js
 **/